export default {
  translations: {
    webcast: {
      buttonGroup: {
        slide: `Slide`,
        video: `Video`,
        split: `Split`,
      },
      supportTab: {
        tooltip: `Technical Support`,
        content: `email: atendimento@riprisma.com`,
      },
      downloadFileTab: {
        tooltip: `Files`,
      },
      connectionTab: {
        tooltip: `Connection`,
      },
      infoTab: {
        tooltip: `Info`,
      },
      chatTab: {
        tooltip: `Enter your message...`,
        title: `Chat`,
        button: `Send`,
        unvaibleMessage: `Chat is unavailable`,
      },
      chatButton: {
        text: `Q&A`,
      },
      inviteTab: {
        label: `Email`,
        tooltip: `Invite`,
        button: `Invite`,
        inviteSent: `Your invitation was sent successfully.`,
        errorEmptyEmail: `It is mandatory to enter your e-mail.`,
        errorInvalidEmail: `The e-mail address you entered is invalid.`,
        errorSendEmail: `Error sending email. Please, retry.`,
      },
      speakerTab: {
        tooltip: `Speaker`,
      },
      eventFinished: {
        browserTitle: `The Event ended`,
        title: `Your live event is available on the web`,
        castFinished: `Event ended`,
        castMessage: `This Event has ended.`,
      },
      eventStarts: {
        title: `Event Waiting`,
        castStarts: `Expected start of the event:`,
        castMessage: `Check your inbox for more information`,
      },
      eventClosed: {
        closed: `Waiting`,
        castClosed: `Event Closed`,
      },
      requirements: {
        tooltip: `Requirements page`,
        title: `Requirements page`,
        content: {
          title: `Connection problems`,
          version: `version`,
          higher: `or higher`,
          download: `Download the most recent version*`,
          browser: `Browser`,
          wsUpdates: `and all Microsoft Updates`,
          processorTitle: `Processor`,
          processorTxt: `Intel Pentium 4 or equivalent with 1 GHz processor`,
          ram: `256MB RAM (512 MB recommended)`,
          resolution: `Minimum Resolution`,
          resolutionNote: `Note`,
          resolutionNoteTxt: `These settings are subjected to regular tests for every product release. Other environments, such as Linux and different browser versions, may also work, but are not recommended.`,
          mobile: `Supported Mobile Devices`,
          portDomainTitle: `Ports and Domains`,
          portDomainTxt: `Your network or computer may have a firewall that blocks our services. Make sure that the following domains, IPs and ports are not being blocked by your network and/or computer.`,
          ports: `Ports`,
          protocols: `Protocols`,
          antiVirus: `Anti-Virus and Anti-Malware programs may also block our domains and ports, causing problems. Check to see if anything is being blocked by these types of software.`,
          urlAvailability: `(*) The availability of the URLs listed above is the responsibility of the manufacturers and may change without notice. If these URLs are unavailable, we recommend performing a search on the manufacturer's website or using a search engine.`,
        },
      },
      connection: {
        connected: `Your connection was recovered.`,
        notConnected: `You lost connection. trying to reconnect`,
      },
      of: `of`,
      stanby: `Stand by`,
      castStart: `This event begins`,
      term: `Term of Consent`,
      liveEvent: `Your live event is available on the web`,
      sidebar: {
        title: `About this event`,
      },
      footer: {
        followButton: `Follow speaker`,
      },
      player: {
        playMessage: `Click to Play`,
      },
    },
    register: {
      loading: `Loading...`,
      browserTitle: `Register`,
      labelSubmit: `Enter`,
      initRegister: `Register`,
      initRegisterText: `It is necessary to fill in the information below to participate in this Event.`,
      conference: `Conference call of`,
      results: `Results`,
      name: `Name`,
      email: `E-mail`,
      company: `Company`,
      phone: `Phone number`,
      phoneInfo: `Special characters (such as + or -) are not accepted!`,
      userType: `Profile`,
      selectLabel: `Select`,
      termsAcceptMessage: `By continuing, you agree to the`,
      terms: `Terms`,
      dateFormat: `MM/dd/yyyy - HH:mm`,
      acceptTerms: `I have read and agree to the`,
      useTerms: `Terms`,
      privacyPolicy: `Privacy Policy`,
      useTermsAnd: `and the`,
      linkTerms: `https://www.riprisma.com/privacy-policy`,
      useTermsPrisma: ``,
      validations: {
        name: {
          required: `Field Name is required`,
          max: `Field Name Allow maximum 200 characters.`,
        },
        email: {
          valid: `Inserted E-mail is invalid`,
          required: `Field E-mail is required`,
          max: `Field E-mail Allow maximum 200 characters.`,
        },
        typeUser: {
          required: `Field Profile is required`,
        },
        company: {
          max: `Field Company Allow maximum 400 characters.`,
        },
        phone: {
          max: `Field Phone number Allow maximum 200 characters.`,
          required: `Field Phone number is required.`,
        },
      },
    },
    footer: {
      allRightsReserved: `All rights reserved`,
    },
  },
};
